module.exports = __webpack_public_path__ + "6c03134f5559510c33aba2c332be9019.png";